import {Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'dmmp-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  @Input() openModal = false
  @Input() locationVertical
  @Output() showModal = new EventEmitter()

  closeOutside(data) {
    if (data.target.id === 'modal_cover') {
      this.showModal.emit()
      this.openModal = false
    }
  }
}
